/*
choixPAGE==0 : nouveau qcm
choixPAGE==1 : modifier-supprimer
choixPAGE==2 : le menu QCM pour le qcm sélectionné !
choixPAGE==3 : liste des qcm

choixQCM=-1 : pas choisi
choixQCM>0 : idqcm

*/


app.directive('ngConfirmClick', [
    function () {
        return {
            priority: 1,
            terminal: true,
            link: function (scope, element, attr) {
                var msg = attr.ngConfirmClick || "___Vous confirmez___ ?";
                var clickAction = attr.ngClick;
                element.bind('click', function (event) {
                    if (window.confirm(msg)) {
                        scope.$eval(clickAction)
                    }
                });
            }
        };
    }])

app.directive('restrictInput', [function () {

    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var ele = element[0];
            var regex = RegExp(attrs.restrictInput);
            var value = ele.value;

            ele.addEventListener('keyup', function (e) {
                if (ele.value == "") {
                    ele.value = 0;
                } else if (ele.value < 0) {
                    ele.value = 0;
                } else if (ele.value > 16) {
                    ele.value = 16;
                } else if (regex.test(ele.value)) {
                    value = ele.value;
                } else {
                    ele.value = value;
                }
            });
        }
    };
}]);


app.controller('qcmCtrl', function ($rootScope, $scope, listeQCM, $location, ServiceQcm, toastr, services, $auth) {
    var _DEBUG = 0;
    $scope.url_ = $rootScope.url_;

    $scope.menuSelectionne = 1;
    $scope.Caffiche = 1;
    $scope.nom = "corentin";
    $rootScope.menu1 = 10
    if (typeof $rootScope.qcmSelectionne === 'undefined' || $rootScope.qcmSelectionne === null) {
        $location.path('/0lst');
    }/*else{
        $scope.choixQCM = $rootScope.qcmSelectionne.id;
        $scope.choixPAGE=2
    }*/

    /**********************************/
    //$scope.nombrePage=2
    //$scope.nombrePageTab = {"1":10,"2":10,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0}
    $scope.init = function () {
        $scope.loader = 1;
        if (typeof ($rootScope.qcmSelectionne) === 'undefined') { $location.path('/0lst'); }
        /*
            $scope.qcmSelectionne = $rootScope.qcmSelectionne;
            $scope.choixQCM = $rootScope.qcmSelectionne.id
            //$scope.qcmSelectionne.id = $rootScope.qcmSelectionne.id
            $scope.info=$rootScope.qcmSelectionne.info
            $scope.TABlisteEtudiant=$rootScope.qcmSelectionne.TABlisteEtudiant
        
            $scope.qcmSelectionne.id = qcm.id
        */
        new ServiceQcm.chargement($rootScope.qcmSelectionne).then(function (data) {
            $scope.qcmSelectionne = data
            $rootScope.qcmSelectionne = data
            $scope.choixQCM = $rootScope.qcmSelectionne.id
            $scope.choixPAGE = 2
            //alert("fini")
            $scope.message();

            $scope.loader = 0;
        })
            .catch(function (response) {
                //if (_DEBUG) console.info('message='+response.data.message+' et ='+ response.status);
                //throw(response);
                toastr.error("___session expirée___");
                $scope.loader = 0;
                $location.path('/QCMscanner');
            })

    }
    /******************************************************************************************************/
    $scope.gotopdfetudiant = function (id, nbQ, nbReponse) {

        services.gotopdfetudiant(id, nbQ, nbReponse)
            .then(function (data) {
            })
            .catch(function (response) {
            })
            .finally(function (data) {
            })
    }
    /******************************************************************************************************/
    $scope.cancel = function () { //revenir à la liste des qcm
        $location.path('/0lst');
    }
    /******************************************************************************************************/

    $scope.close = function (result) {   // modal !
        close(result, 500); // close, but give 500ms for bootstrap to animate
    };
    $scope.testC = function () {   // modal !
        //alert("ok");
        if ($scope.Caffiche == 1)
            $scope.Caffiche = 0; // close, but give 500ms for bootstrap to animate
        else
            $scope.Caffiche = 1;
    };

    /******************************************************************************************************/
    $scope.message = function () { //, affiche des infos...


        $scope.qcmSelectionne.info = {}
        $rootScope.qcmSelectionne.info = {}
        $rootScope.qcmSelectionne.info.t0 = "";
        $rootScope.qcmSelectionne.info.c0 = ""
        $rootScope.qcmSelectionne.info.t1 = "";
        $rootScope.qcmSelectionne.info.c1 = ""


        var count = 0;
        var str = $rootScope.qcmSelectionne.qcmSolution
        var pos = str.indexOf("(");

        while (pos != -1) {
            count++;
            pos = str.indexOf("(", pos + 1);
        }

        if (count == $rootScope.qcmSelectionne.nbQ) { $rootScope.qcmSelectionne.info.t0 = "___Saisir la solution___"; $rootScope.qcmSelectionne.info.c0 = "#C9302C" }
        else if (count > 0) { $rootScope.qcmSelectionne.info.t0 = "___Certaines questions n'ont pas de solutions___"; $rootScope.qcmSelectionne.info.c0 = "#EC971F" }
        else { $rootScope.qcmSelectionne.info.t0 = "___Solution ok___"; $rootScope.qcmSelectionne.info.c0 = "#449D44" }

        if ($rootScope.qcmSelectionne.nbEtudiant == 0) { $rootScope.qcmSelectionne.info.t1 = "___saisir les étudiants___"; $rootScope.qcmSelectionne.info.c1 = "#C9302C" }
        //    else if (){$scope.info.etudiant="___saisir les étudiants___"; $scope.info.etudiant.couleur="Danger"}
        else { $rootScope.qcmSelectionne.info.t1 = "___Etudiant ok___"; $rootScope.qcmSelectionne.info.c1 = "#449D44" }

        if ($rootScope.qcmSelectionne.listeCopie.length == 0) { $rootScope.qcmSelectionne.info.t2 = "___Envoyer les copies___"; $rootScope.qcmSelectionne.info.c2 = "#C9302C" }
        //     else if (count>0){$rootScope.qcmSelectionne.info.t2="___Certaines copies ne sont pas identifiées___"; $rootScope.qcmSelectionne.info.c2="#EC971F"}
        //    else if (count>0){$rootScope.qcmSelectionne.info.t2="___Erreur d'étudiant sur des copies___"; $rootScope.qcmSelectionne.info.c2="#EC971F"}
        else { $rootScope.qcmSelectionne.info.t2 = "___Copies ok___"; $rootScope.qcmSelectionne.info.c2 = "#449D44" }

        //    if ($rootScope.qcmSelectionne.listeCopie.length==0){$rootScope.qcmSelectionne.info.t3="___envoyer les copies___"; $rootScope.qcmSelectionne.info.c3="#C9302C"}
        //    else if (count>0){$rootScope.qcmSelectionne.info.t3="___Certaines copies ne sont pas identifiées___"; $rootScope.qcmSelectionne.info.c3="#EC971F"}
        //    else {$rootScope.qcmSelectionne.info.t3="___Correction prête___"; $rootScope.qcmSelectionne.info.c3="#449D44"}

        $scope.info = $rootScope.qcmSelectionne.info

    }
    /******************************************************************************************************/

    $scope.isAuthenticated = function () { //, service_Charge1qcm
        $rootScope.qcmSelectionne = [];
        $scope.choixPAGE = 3
        return $auth.isAuthenticated();

    }

    /******************************************************************************************************/

});
